import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import firebase from 'firebase';
import { AlertService } from 'src/app/services/alert/alert.service';
import { RouterService } from 'src/app/services/router/router.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ChangePhoneOtpPage } from '../../private/change-phone-otp/change-phone-otp.page';

@Component({
  selector: 'app-recover-method',
  templateUrl: './recover-method.page.html',
  styleUrls: ['./recover-method.page.scss'],
})
export class RecoverMethodPage implements OnInit {

  email = '';
  phone = '';
  emailMask = '';
  phoneMask = '';

  constructor(private router: Router,
    private alertService: AlertService,
    private storageService: StorageService,
    private routerService: RouterService
    ) { }

  async ngOnInit() {
    this.email = await this.storageService.get('emailRecover');
    this.phone = await this.storageService.get('phoneRecover');
    if(!this.email || !this.phone){
      return this.router.navigateByUrl('login');
    }
    this.emailMask = this.email.slice(0, 3) + this.email.slice(3, this.email.split('@')[0].length -2).replace(/./g, '*') + (this.email).slice(this.email.split('@')[0].length -2); 
    this.phoneMask = this.phone.slice(3, 7) + this.phone.slice(7, 11).replace(/./g, '*') + (this.phone).slice(11);
  }
  
  async ionViewDidEnter(){
    this.email = await this.storageService.get('emailRecover');
    this.phone = await this.storageService.get('phoneRecover');

    if(!this.email || !this.phone){
      return this.router.navigateByUrl('login');
    }
  }

  validateEmail(){
    this.sendRecoverEmail(this.email)
  }

  validatePhone(){
    this.router.navigateByUrl('otp');
  }

  sendRecoverEmail(email) {
    firebase.auth().sendPasswordResetEmail(email)
      .then((res) => {
        this.router.navigateByUrl('confirm-auth');
      })
      .catch((error) => {
        console.error(error);
        switch (error.code) {
          case 'auth/invalid-email':
            
            break;
          case 'auth/missing-android-pkg-name':

            break;
          case 'auth/missing-continue-uri':

            break;
          case 'auth/missing-ios-bundle-id':

            break;
          case 'auth/invalid-continue-uri':

            break;
          case 'auth/unauthorized-continue-uri':

            break;
          case 'auth/user-not-found':

            break;
          default:
            break;
        }
      });
  }

}
